<template>
  <div class="room_extra_wrap">
    <button
      class="room_extra hover_op"
      @click="show_drop = !show_drop"
      v-click-outside="hide"
    ></button>

    <div class="extras_drop drop" :class="{ active: show_drop }">

      <button @click="(show_drop = false), $emit('duplicateBtnClick')">
        Duplicate
      </button>

      <button @click="(show_drop = false), $emit('editBtnClick')">Edit</button>

      <button @click="(show_drop = false), $emit('removeBtnClick')">
        Remove
      </button>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  emits: ["removeBtnClick", "editBtnClick"],

  data() {
    return {
      show_drop: false,
    };
  },

  methods: {
    hide() {
      this.show_drop = false;
    },
  },

  mounted() {
    this.popupItem = this.$el;
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
.room_extra_wrap {
  display: flex;
  align-items: center;
}
</style>